import { render, staticRenderFns } from "./CompletedAutoRtConsent.vue?vue&type=template&id=7cca84f5&scoped=true"
import script from "./CompletedAutoRtConsent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletedAutoRtConsent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompletedAutoRtConsent.vue?vue&type=style&index=0&id=7cca84f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca84f5",
  null
  
)

export default component.exports